<template>
    <div>
        <div>
            <div class="card">
                <div class="tw-flex tw-justify-between">
                    <h2 class="card-title tw-justify-start">
                        <span>📅</span>
                        {{ $t("loanDisbursement.repaymentSchedule") }}
                    </h2>
                    <div class="tw-justify-end">
                        <ts-button
                            :disabled="!isRepaymentSchedules"
                            color="primary"
                            class="btn-xs tw-mr-2"
                            @click="generatePDF()"
                            :waiting="generating"
                            ><i class="far fa-file-pdf" v-if="!generating"></i>
                            {{
                                $t("loanDisbursement.customerSchedule")
                            }}</ts-button
                        >
                        <ts-button
                            :disabled="!isRepaymentSchedules"
                            color="danger"
                            class="btn-xs tw-mr-2"
                            @click="previewPdf(1)"
                            ><i class="far fa-file-pdf"></i>
                            {{ $t("previewPdf") }}</ts-button
                        >
                        <ts-button
                            :disabled="!isRepaymentSchedules"
                            color="success"
                            class="btn-xs tw-mr-2"
                            @click="onExportExcel"
                        >
                            <i
                                class="fas fa-circle-notch fa-spin"
                                v-if="exporting"
                            ></i>
                            <i class="far fa-file-excel" v-else></i>
                            {{ $t("exportExcel") }}</ts-button
                        >
                    </div>
                </div>
                <div class="overflow-auto">
                    <div class="demo-spin-article">
                        <div style="height:30vh">
                            <table class="schedule-table">
                                <thead class="schedule-header">
                                    <tr>
                                        <th width="1%" class="tw-text-center">
                                            {{ $t("No") }}
                                        </th>
                                        <th width="15%" class="tw-text-center tw-whitespace-nowrap">
                                            {{
                                                $t(
                                                    "loanDisbursement.paymentDate"
                                                )
                                            }}
                                        </th>
                                        <th width="15%" class="tw-text-center tw-whitespace-nowrap">
                                            {{
                                                $t("loanDisbursement.principle")
                                            }}
                                        </th>
                                        <th class="tw-text-center tw-whitespace-nowrap" width="15%">
                                            {{
                                                $t("loanDisbursement.interest")
                                            }}
                                        </th>
                                        <th class="tw-text-center tw-whitespace-nowrap" width="15%">
                                            {{
                                                $t(
                                                    "loanDisbursement.monthlyFee"
                                                )
                                            }}
                                        </th>
                                        <th class="tw-text-center tw-whitespace-nowrap" width="15%">
                                            {{
                                                $t("loanDisbursement.rescueFee")
                                            }}
                                        </th>
                                        <th class="tw-text-center tw-whitespace-nowrap" width="15%">
                                            {{
                                                $t(
                                                    "loanDisbursement.amountRepay"
                                                )
                                            }}
                                        </th>
                                        <th class="tw-text-center tw-whitespace-nowrap" width="15%">
                                            {{ $t("loanDisbursement.balance") }}
                                        </th>
                                        <th width="15%" class="text-center tw-whitespace-nowrap">
                                            {{ $t("loanDisbursement.payType") }}
                                        </th>
                                        <th class="text-center" width="10%">
                                            {{ $t("loanDisbursement.paid") }}
                                        </th>
                                    </tr>
                                </thead>
                                <tbody v-if="isRepaymentSchedules">
                                    <tr
                                        v-for="(row,
                                        index) in edit_data.repayment_schedules"
                                        :key="index"
                                        class="schedule-row"
                                    >
                                        <td
                                            class="tw-whitespace-nowrap tw-text-center"
                                        >
                                            {{ index + 1 }}
                                        </td>
                                        <td
                                            class="tw-whitespace-nowrap tw-text-center"
                                        >
                                            {{ row.cycle_payment_date }}
                                        </td>
                                        <td
                                            class="tw-whitespace-nowrap amount-cell"
                                        >
                                            <div
                                                class="tw-flex tw-justify-between"
                                            >
                                                <span class="text-left">{{
                                                    signBycurrencyId(
                                                        edit_data.currency_id
                                                    )
                                                }}</span>
                                                <span class="text-right">{{
                                                    formatNumber(
                                                        row.principal,
                                                        edit_data.currency_id
                                                    )
                                                }}</span>
                                            </div>
                                        </td>
                                        <td class="tw-whitespace-nowrap">
                                            <div
                                                class="tw-flex tw-justify-between"
                                            >
                                                <span class="text-left">{{
                                                    signBycurrencyId(
                                                        edit_data.currency_id
                                                    )
                                                }}</span>
                                                <span class="text-right">{{
                                                    formatNumber(
                                                        row.interest,
                                                        edit_data.currency_id
                                                    )
                                                }}</span>
                                            </div>
                                        </td>
                                        <td class="tw-whitespace-nowrap">
                                            <div
                                                class="tw-flex tw-justify-between"
                                            >
                                                <span class="text-left">{{
                                                    signBycurrencyId(
                                                        edit_data.currency_id
                                                    )
                                                }}</span>
                                                <span class="text-right">{{
                                                    formatNumber(
                                                        row.monthly_fee,
                                                        edit_data.currency_id
                                                    )
                                                }}</span>
                                            </div>
                                        </td>
                                        <td class="tw-whitespace-nowrap">
                                            <div
                                                class="tw-flex tw-justify-between"
                                            >
                                                <span class="text-left">{{
                                                    signBycurrencyId(
                                                        edit_data.currency_id
                                                    )
                                                }}</span>
                                                <span class="text-right">{{
                                                    formatNumber(
                                                        row.rescue_fee,
                                                        edit_data.currency_id
                                                    )
                                                }}</span>
                                            </div>
                                        </td>
                                        <td
                                            class="tw-whitespace-nowrap amount-cell"
                                        >
                                            <div
                                                class="tw-flex tw-justify-between"
                                            >
                                                <span class="text-left">{{
                                                    signBycurrencyId(
                                                        edit_data.currency_id
                                                    )
                                                }}</span>
                                                <span class="text-right">{{
                                                    formatNumber(
                                                        row.total_amount,
                                                        edit_data.currency_id
                                                    )
                                                }}</span>
                                            </div>
                                        </td>
                                        <td
                                            class="tw-whitespace-nowrap balance-cell"
                                        >
                                            <div
                                                class="tw-flex tw-justify-between"
                                            >
                                                <span class="text-left">{{
                                                    signBycurrencyId(
                                                        edit_data.currency_id
                                                    )
                                                }}</span>
                                                <span class="text-right">{{
                                                    formatNumber(
                                                        row.ending_balance,
                                                        edit_data.currency_id
                                                    )
                                                }}</span>
                                            </div>
                                        </td>
                                        <td
                                            class="tw-whitespace-nowrap tw-text-center"
                                        >
                                            {{
                                                row.installment_type == 1
                                                    ? "Principal/Interest"
                                                    : "Interest"
                                            }}
                                        </td>
                                        <td
                                            class="text-center tw-whitespace-nowrap tw-justify-items-center tw-items-center"
                                        >
                                            <Checkbox
                                                v-model="row.is_paid"
                                                :disabled="true"
                                            ></Checkbox>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                    <Spin size="large" fix v-if="scheduleLoading"> </Spin>
                </div>

                <div class="summary-stats">
                    <div class="stat-item">
                        <div class="stat-value">
                            {{ signBycurrencyId(edit_data.currency_id)
                            }}{{
                                formatNumber(
                                    totalPrincipal,
                                    edit_data.currency_id
                                )
                            }}
                        </div>
                        <div class="stat-label">{{ $t("loanDisbursement.totalPrincipal") }}</div>
                    </div>
                    <div class="stat-item">
                        <div class="stat-value">
                            {{ signBycurrencyId(edit_data.currency_id)
                            }}{{
                                formatNumber(
                                    totalInterest,
                                    edit_data.currency_id
                                )
                            }}
                        </div>
                        <div class="stat-label">{{ $t("loanDisbursement.totalInterest") }}</div>
                    </div>
                    <div class="stat-item">
                        <div class="stat-value">
                            {{ signBycurrencyId(edit_data.currency_id)
                            }}{{
                                formatNumber(
                                    totalFee,
                                    edit_data.currency_id
                                )
                            }}
                        </div>
                        <div class="stat-label">{{ $t("loanDisbursement.totalFees") }}</div>
                    </div>
                    <div class="stat-item">
                        <div class="stat-value">
                            {{ signBycurrencyId(edit_data.currency_id)
                            }}{{
                                formatNumber(
                                    totalAmountRepay,
                                    edit_data.currency_id
                                )
                            }}
                        </div>
                        <div class="stat-label">{{ $t("loanDisbursement.finalAmount") }}</div>
                    </div>
                </div>
            </div>
        </div>
        <pdf-preview
            v-model="pdf_view"
            :id-lists="loanIdLists"
            :type="type"
            @cancel="value => (pdf_view = value)"
        />
        <vue-html2pdf
            :show-layout="false"
            :float-layout="true"
            :enable-download="false"
            :preview-modal="true"
            :paginate-elements-by-height="1400"
            filename="customer-repayment-schedule"
            :pdf-quality="2"
            :manual-pagination="false"
            pdf-format="a4"
            :pdf-margin="10"
            pdf-orientation="portrait"
            pdf-content-width="800px"
            ref="html2Pdf"
            @beforeDownload="beforeGenerate()"
            @hasDownloaded="hasGenerated()"
        >
            <section slot="pdf-content">
                <CustomerRepaymentScheduleEN
                    v-if="$root.$i18n.locale === 'en'"
                    :loan="loan"
                />
                <CustomerRepaymentScheduleKH v-else :loan="loan" />
            </section>
        </vue-html2pdf>
    </div>
</template>

<script>
import { mapGetters, mapState } from "vuex";
import { isEmpty } from "lodash";
import PdfPreview from "./pdf-preview";
import { trim } from "lodash";
import * as FileDownload from "downloadjs";

import VueHtml2pdf from "vue-html2pdf";
import CustomerRepaymentScheduleEN from "./customer-repayment-schedule-en.vue";
import CustomerRepaymentScheduleKH from "./customer-repayment-schedule-kh.vue";

export default {
    name: "repaymentSchedule",
    components: {
        PdfPreview,
        VueHtml2pdf,
        CustomerRepaymentScheduleEN,
        CustomerRepaymentScheduleKH
    },
    data() {
        return {
            scheduleLoading: false,
            pdf_view: false,
            exporting: false,
            type: 1,
            generating: false,
            loan: {}
        };
    },
    computed: {
        ...mapState("creditOperation/loanDisbursement", ["edit_data"]),
        ...mapGetters(["formatNumber", "signBycurrencyId"]),
        loanIdLists() {
            if (!isEmpty(this.edit_data)) {
                return [this.edit_data.loan_id];
            }
            return [];
        },
        isRepaymentSchedules() {
            if (!isEmpty(this.edit_data)) {
                return true;
            }
            return false;
        },
        totalPrincipal() {
            if (this.isRepaymentSchedules) {
                return parseFloat(
                    this.edit_data.repayment_schedules
                        .reduce((n, { principal }) => n + principal, 0)
                        .toFixed(4)
                );
            }
            return 0;
        },
        totalInterest() {
            if (this.isRepaymentSchedules) {
                return parseFloat(
                    this.edit_data.repayment_schedules
                        .reduce((n, { interest }) => n + interest, 0)
                        .toFixed(4)
                );
            }
            return 0;
        },
        totalFee() {
            if (this.isRepaymentSchedules) {
                return parseFloat(
                    this.edit_data.repayment_schedules
                        .reduce((n, { rescue_fee }) => n + rescue_fee, 0)
                        .toFixed(4)
                ) + parseFloat(
                    this.edit_data.repayment_schedules
                        .reduce((n, { monthly_fee }) => n + monthly_fee, 0)
                        .toFixed(4)
                );
            }
            return 0;
        },
        totalAmountRepay() {
            if (this.isRepaymentSchedules) {
                return parseFloat(
                    this.edit_data.repayment_schedules
                        .reduce((n, { total_amount }) => n + total_amount, 0)
                        .toFixed(4)
                );
            }
            return 0;
        },
        totalNumberOfPayment() {
            if (this.isRepaymentSchedules) {
                return this.edit_data.repayment_schedules.filter(function(s) {
                    return s.is_paid;
                }).length;
            }
            return 0;
        }
    },
    methods: {
        previewPdf(type) {
            this.pdf_view = true;
            this.type = type;
        },
        onExportExcel() {
            this.exporting = true;
            this.$store
                .dispatch("creditOperation/loanDisbursement/exportExcel", {
                    loan_id_lists: this.loanIdLists
                })
                .then(response => {
                    let filename = trim(
                        response.headers["content-disposition"]
                            .substring(
                                response.headers["content-disposition"].indexOf(
                                    "filename"
                                )
                            )
                            .replace("filename=", ""),
                        '"'
                    );
                    FileDownload(response.data, filename);
                })
                .catch(err => {
                    let error = JSON.parse(
                        String.fromCharCode.apply(null, new Uint8Array(err))
                    );
                    this.notice({ type: "error", text: error.message });
                })
                .finally(() => {
                    this.exporting = false;
                });
        },
        beforeGenerate() {
            this.generating = true;
        },
        hasGenerated() {
            this.generating = false;
        },
        generatePDF() {
            this.loan = this.edit_data;
            this.$refs.html2Pdf.generatePdf();
        }
    }
};
</script>
<style scoped>
.card {
    background: rgba(255, 255, 255, 0.95);
    border-radius: 20px;
    padding: 15px;
    backdrop-filter: blur(20px);
    box-shadow: 0 8px 32px rgba(0, 0, 0, 0.1);
    border: 1px solid rgba(255, 255, 255, 0.2);
}

.card-title {
    font-size: 20px;
    font-weight: 600;
    margin-bottom: 10px;
    color: #333;
}

/* Payment Schedule */
.schedule-table {
    width: 100%;
    border-collapse: collapse;
    background: white;
    border-radius: 12px;
    overflow: hidden;
    box-shadow: 0 4px 16px rgba(0, 0, 0, 0.05);
}

.schedule-header {
    background: linear-gradient(135deg, #667eea, #764ba2);
    color: white;
}

.schedule-header th {
    padding: 10px 12px;
    font-weight: 600;
    font-size: 12px;
    text-transform: uppercase;
    letter-spacing: 0.5px;
    position: sticky;
    top: 0;
    z-index: 1;
}

.schedule-row {
    transform: scale(1);
    transition: transform 0.2s ease;
}
.schedule-row td {
    padding: 6px;
    border-bottom: 1px solid #f1f5f9;
    font-size: 13px;
}

.schedule-row:hover {
    background: #f8fafc;
    transform: scale(1.01);
    transition: transform 0.2s ease;
}

.amount-cell {
    font-weight: 600;
    color: #059669;
}

.balance-cell {
    font-weight: 600;
    color: #dc2626;
}

/* Animations */
@keyframes slideIn {
    from {
        opacity: 0;
        transform: translateY(20px);
    }
    to {
        opacity: 1;
        transform: translateY(0);
    }
}

.card {
    animation: slideIn 0.6s ease-out;
}

.summary-stats {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(150px, 1fr));
    gap: 16px;
    margin-top: 10px;
}

.stat-item {
    text-align: center;
    padding: 10px;
    background: #f8fafc;
    border-radius: 12px;
}

.stat-value {
    font-size: 20px;
    font-weight: 700;
    color: #667eea;
}

.stat-label {
    font-size: 12px;
    color: #64748b;
    margin-top: 4px;
}
</style>
